// CONSTANTS
export const Constants = {
  CLIENTSIDE_TRANSITION: 'CLIENTSIDE_TRANSITION_COLLECTION',
  UPDATE_ALGOLIA: 'UPDATE_ALGOLIA_COLLECTION',
  UPDATE_HITS_PER_PAGE: 'UPDATE_HITS_PER_PAGE_COLLECTION',
  UPDATE_PAGE: 'UPDATE_PAGE_COLLECTION',
  UPDATE_URL: 'UPDATE_URL_COLLECTION',
}
// ACTION TYPES
export type CollectionsActionTypes =
  | {
      type: typeof Constants.CLIENTSIDE_TRANSITION
      payload: string
    }
  | {
      type: typeof Constants.UPDATE_ALGOLIA
      payload?: Record<string, any>
    }
  | {
      type: typeof Constants.UPDATE_HITS_PER_PAGE
      payload: number
    }
  | {
      type: typeof Constants.UPDATE_PAGE
      payload: number
    }
  | {
      type: typeof Constants.UPDATE_URL
      payload: string
    }

// ACTION CALLS
export const Actions = {
  CLIENTSIDE_TRANSITION: (payload: string): CollectionsActionTypes => ({
    type: Constants.CLIENTSIDE_TRANSITION,
    payload,
  }),
  UPDATE_ALGOLIA: (payload?: Record<string, any>): CollectionsActionTypes => ({
    type: Constants.UPDATE_ALGOLIA,
    payload,
  }),
  UPDATE_HITS_PER_PAGE: (payload: number): CollectionsActionTypes => ({
    type: Constants.UPDATE_HITS_PER_PAGE,
    payload,
  }),
  UPDATE_PAGE: (payload: number): CollectionsActionTypes => ({
    type: Constants.UPDATE_PAGE,
    payload,
  }),
  UPDATE_URL: (payload: string): CollectionsActionTypes => ({
    type: Constants.UPDATE_URL,
    payload,
  }),
}
